/* SVADEZI customer login. Mobile OTP via the Supabase mto-otp edge function.
 *
 * Contract (mto-otp):
 *   {action:"request", identifier}        -> {ok:true, channel, sentVia} | {ok:true, resendInSeconds}
 *   {action:"verify",  identifier, code}  -> {ok:true, token, identifier, channel, orders, shopify_orders}
 *                                         -> {ok:false, error}
 * The endpoint returns HTTP 200 for soft errors, so always read ok/error from
 * the body rather than trusting the status code.
 *
 * The raw session token is returned exactly once, on verify. Only its hash is
 * stored server-side. We keep it in localStorage so the session survives a tab
 * close, which is the point of a 30-day session.
 */
(function () {
  var cfg = window.__MTO_LOGIN_CONFIG__ || {};
  var root = document.querySelector("[data-mto-login]");
  if (!root) return;

  var SESSION_KEY = "svz-session";

  var stepPhone = root.querySelector('[data-login-step="phone"]');
  var stepCode = root.querySelector('[data-login-step="code"]');
  var elPhone = root.querySelector("[data-login-phone]");
  var elCode = root.querySelector("[data-login-code]");
  var elSend = root.querySelector("[data-login-send]");
  var elVerify = root.querySelector("[data-login-verify]");
  var elResend = root.querySelector("[data-login-resend]");
  var elBack = root.querySelector("[data-login-back]");
  var elFlash = root.querySelector("[data-login-flash]");
  var elSentTo = root.querySelector("[data-login-sentto]");

  var identifier = "";
  var cooldownTimer = null;

  function flash(msg, tone) {
    if (!elFlash) return;
    if (!msg) { elFlash.hidden = true; elFlash.textContent = ""; return; }
    elFlash.textContent = msg;
    elFlash.setAttribute("data-tone", tone || "info");
    elFlash.hidden = false;
  }

  function nextUrl() {
    try {
      var n = new URLSearchParams(window.location.search).get("next");
      // Only allow same-site relative paths, so ?next= cannot become an open redirect.
      if (n && n.charAt(0) === "/" && n.charAt(1) !== "/") return n;
    } catch (e) {}
    return cfg.dashboardUrl || "/pages/dashboard";
  }

  function api(payload) {
    return fetch(cfg.supabaseUrl + "/functions/v1/mto-otp", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        apikey: cfg.supabaseKey,
        Authorization: "Bearer " + cfg.supabaseKey
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    });
  }

  // Ten digits is what an Indian mobile is; mto-otp prepends 91 itself.
  function cleanPhone(v) {
    return String(v || "").replace(/\D+/g, "").slice(-10);
  }

  function startCooldown(seconds) {
    if (!elResend) return;
    var left = seconds;
    elResend.disabled = true;
    if (cooldownTimer) clearInterval(cooldownTimer);
    function tick() {
      if (left <= 0) {
        clearInterval(cooldownTimer);
        cooldownTimer = null;
        elResend.disabled = false;
        elResend.textContent = "Resend code";
        return;
      }
      elResend.textContent = "Resend in " + left + "s";
      left -= 1;
    }
    tick();
    cooldownTimer = setInterval(tick, 1000);
  }

  function showCodeStep(sentVia) {
    if (stepPhone) stepPhone.hidden = true;
    if (stepCode) stepCode.hidden = false;
    if (elSentTo) {
      var where = sentVia === "whatsapp" ? "on WhatsApp" : sentVia === "sms" ? "by SMS" : "to you";
      elSentTo.textContent = "We sent a 6-digit code " + where + " to +91 " + identifier.slice(-10) + ".";
    }
    if (elCode) elCode.focus();
    startCooldown(45);
  }

  function request(isResend) {
    var ten = cleanPhone(elPhone && elPhone.value);
    if (ten.length !== 10) { flash("Enter a valid 10-digit mobile number.", "error"); return; }
    identifier = ten;

    var btn = isResend ? elResend : elSend;
    if (btn) btn.disabled = true;
    flash("");

    api({ action: "request", identifier: ten })
      .then(function (j) {
        if (j && j.error) { flash(j.error, "error"); return; }
        if (j && j.resendInSeconds) {
          // Already sent recently; move on and let the countdown run.
          if (stepCode && stepCode.hidden) showCodeStep(null);
          startCooldown(j.resendInSeconds);
          flash("A code was just sent. Check WhatsApp, or wait to resend.", "info");
          return;
        }
        if (isResend) { flash("Code resent.", "info"); startCooldown(45); }
        else showCodeStep(j && j.sentVia);
      })
      .catch(function () {
        flash("We could not reach our atelier just now. Check your connection and try again.", "error");
      })
      .finally(function () {
        if (btn && btn !== elResend) btn.disabled = false;
      });
  }

  function verify() {
    var code = String((elCode && elCode.value) || "").replace(/\D+/g, "");
    if (code.length !== 6) { flash("Enter the 6-digit code.", "error"); return; }
    if (elVerify) elVerify.disabled = true;
    flash("");

    api({ action: "verify", identifier: identifier, code: code })
      .then(function (j) {
        if (!j || j.ok !== true) {
          flash((j && j.error) || "That code did not work. Please try again.", "error");
          if (elVerify) elVerify.disabled = false;
          return;
        }
        if (!j.token) {
          flash("Signed in, but we could not start a session. Please try again.", "error");
          if (elVerify) elVerify.disabled = false;
          return;
        }
        try { localStorage.setItem(SESSION_KEY, j.token); } catch (e) {}
        flash("Signed in. Taking you to your projects...", "ok");
        window.location.href = nextUrl();
      })
      .catch(function () {
        flash("We could not reach our atelier just now. Check your connection and try again.", "error");
        if (elVerify) elVerify.disabled = false;
      });
  }

  if (elSend) elSend.addEventListener("click", function () { request(false); });
  if (elResend) elResend.addEventListener("click", function () { request(true); });
  if (elVerify) elVerify.addEventListener("click", verify);
  if (elBack) elBack.addEventListener("click", function () {
    if (stepCode) stepCode.hidden = true;
    if (stepPhone) stepPhone.hidden = false;
    flash("");
    if (elPhone) elPhone.focus();
  });

  if (elPhone) elPhone.addEventListener("keydown", function (e) {
    if (e.key === "Enter") { e.preventDefault(); request(false); }
  });
  if (elCode) elCode.addEventListener("keydown", function (e) {
    if (e.key === "Enter") { e.preventDefault(); verify(); }
  });

  // Already signed in? Skip the form entirely.
  var existing = "";
  try { existing = localStorage.getItem(SESSION_KEY) || ""; } catch (e) {}
  if (existing) {
    api({ action: "session", token: existing }).then(function (j) {
      if (j && j.ok === true) window.location.href = nextUrl();
    }).catch(function () {});
  }
})();
